export const Themes = [{
  path: 'themes',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'ThemesPageAdmin',
      component: () => import('../../../components/Admin/Themes.vue'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: 'create',
      name: 'ThemeCreate',
      component: () => import('../../../components/Admin/CreateThemes.vue'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: 'edit/:id',
      name: 'ThemeEdit',
      component: () => import('../../../components/Admin/EditTheme.vue'),
      meta: {
        access: ['admin']
      }
    }
  ]
}]



// WEBPACK FOOTER //
// /src/router/admin/module/themes.js